import { Controller, useFieldArray, useForm } from "react-hook-form";
import { FormControl, TextField } from "@mui/material";
import { default as React, useEffect } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
      width: "100%",
    },
  })
);

export interface item {
  num: number;
  value: number;
}
export interface Form0x30800000 {
  settings: item[];
}

export function Command0x30800000(props) {
  const classes = useStyles();
  const { value, handleChange } = props;

  const commandForm = {
    settings: [],
  };

  const [fields, setFields] = React.useState<Form0x30800000>(commandForm);

  const handleChangeField =
    (prop: keyof Form0x30800000) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleChange(JSON.stringify({ ...fields, [prop]: event.target.value }));
    };

  useEffect(() => {
    const params = JSON.parse(value);

    if (!params.chipID) {
      params.chipID = "";
    }

    setFields(params);
  }, [value]);

  return (
    <>
      {/* <FormControl className={classes.formControl}>
        <TextField
          id="chipID"
          label="ID чипа"
          margin="dense"
          fullWidth
          value={fields.chipID}
          onChange={handleChangeField("chipID")}
        />
      </FormControl> */}
    </>
  );
}
